export const checkIsRestrictedCuratedBrandStoreSelector = () => false;
export const isCuratedBrandStoreSelector = () => false;
export const cbsProductsSelector = state => [];
export const isLoadingSelector = () => false;
export const isCuratedBrandStoreInDraftSelector = () => false;
export const isCuratedBrandStoreActiveSelector = () => false;
export const shouldShowCBSProductsWidgetSelector = () => false;
export const shouldShowCreateCBSButtonSelector = () => false;
export const selectedCBSProductSelector = () => null;
export const categoriesAndFiltersAreHiddenForCBS = state => false;